import React from 'react';
import AddEdit from '../../components/hotel/add_edit/Component';

const Component = () => {
  return (
      <AddEdit componentTitle="Hotel"/>
  )
}

export default Component
